import { z } from 'zod';
const Operations = {
    replace: 'replace',
    add: 'add',
    remove: 'remove',
    test: 'test',
    move: 'move',
    copy: 'copy',
};
export const OperationsEnum = z.nativeEnum(Operations);
const JSONPatchSchema = z.array(z.object({
    op: OperationsEnum,
    path: z.string(),
    value: z.any().optional(),
    from: z.string().optional(),
}));
export const linkSchema = z.object({
    href: z.string(),
    rel: z.string(),
    method: z.string(),
});
export const ESAggregationResultSchema = z.object({
    doc_count_error_upper_bound: z.number().optional(),
    sum_other_doc_count: z.number().optional(),
    buckets: z.array(z.object({
        key: z.union([z.string(), z.array(z.string())]),
        key_as_string: z.string().optional(),
        doc_count: z.number().optional(),
    })),
});
export const ContributionInformationAggregationResultSchema = z.object({
    types: ESAggregationResultSchema,
});
export const LinkTypeSchema = z.object({
    title: z.string().optional(),
    href: z.string(),
});
export const LinkTypeInformationSchema = z.object({
    reference: z.union([z.string(), z.null()]),
    revisionDate: z.union([z.string().datetime(), z.null()]),
});
export const HistoryEventSchema = z.object({
    type: z.string(),
    id: z.string(),
    date: z.string(),
    reference: z.string(),
    user: LinkTypeSchema,
    metadata: z
        .object({
        to: z.string().optional(),
    })
        .optional(),
});
export const HistorySchema = z.object({
    begin: HistoryEventSchema,
    events: z.array(HistoryEventSchema).optional(),
    end: HistoryEventSchema.optional(),
});
// datetime with precision 3 in milliseconds (ex: 2024-04-24T15:38:49.903Z )
export const datetime = z.string().datetime({ precision: 3 });
//# sourceMappingURL=commons.js.map